export default __webpack_public_path__ + "static/logo_white-59427e6bd1b74ab9c2641623e374a9a8.png";